export const publicRoutes = [
  '/login',
  '/signup',
  '/sent-email',
  '/activate',
  '/resetpassword',
  '/success',
  '/activate-failed',
  '/forgot-password',
  '/verify-key',
  '/signup-email-sent',
  '/redirect',
];
